import Vue from 'vue';
import 'normalize.css';

// 插件
import './plugins/element-ui';
import './plugins/v-charts';
import './plugins/lodash';
import './plugins/v-clipboard';

// 主文件
import '../theme/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './permission';

// 样式
import './assets/css/index.styl';
import './assets/css/element.styl';
import './assets/css/transitions.styl';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
